import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 合同相关
 */
const contract = {
  getListElectricOperationsContractForServiceProvider(companyId, clientsCompanyId, startTime, endTime, status) {
    return axios.post(base.contract.listElectricOperationsContractForServiceProvider, utils.postParamsArrayToJsonString({ companyId, clientsCompanyId, startTime, endTime, status }))
  },
  getListElectricOperationsContractForClient(companyId, startTime, endTime, clientsCompanyId, status) {
    return axios.post(base.contract.listElectricOperationsContractForClient, utils.postParamsArrayToJsonString({ companyId, startTime, endTime, clientsCompanyId, status }))
  },
  //查询所有公司
  getListAllCompany() {
    return axios.post(base.contract.listAllCompany, utils.postParamsArrayToJsonString({}))
  },
  // 维保公司查看所有客户
  getListClientsForElectricOperationsCompany(companyId, startTime, endTime) {
    return axios.post(base.contract.listClientsForElectricOperationsCompany, utils.postParamsArrayToJsonString({ companyId, startTime, endTime }))
  },
  // 维保公司查看所有客户
  getListAllUserByCompany(companyId) {
    return axios.post(base.contract.listAllUserByCompany, utils.postParamsArrayToJsonString({ companyId }))
  },
  // 新增合同
  addElectricOperationsContract(params) {
    return axios.post(base.contract.addElectricOperationsContract, utils.postParamsArrayToJsonString({ ...params }))
  },

  // 项目管理
  getContractProjectByContractId(params) {
    return axios.post('/api/getContractProjectByContractId', utils.postParamsArrayToJsonString({ ...params }))
  },
  getContractProjectByIds(projectIds) {
    return axios.post('/api/getContractProjectByIds', utils.postParamsArrayToJsonString({ projectIds }))
  },
  getContractProjectByNumbers(numbers) {
    return axios.post('/api/getContractProjectByNumbers', utils.postParamsArrayToJsonString({ numbers }))
  },
  addContractProject(params) {
    return axios.post('/api/addContractProject', utils.postParamsArrayToJsonString({ ...params }))
  },
  updateContractProjectName(params) {
    return axios.post('/api/updateContractProjectName', utils.postParamsArrayToJsonString({ ...params }))
  },
  deleteContractProjects(projectIds) {
    return axios.post('/api/deleteContractProjects', utils.postParamsArrayToJsonString({ projectIds }))
  },

  getClientContactInfo (projectIds) {
    return axios.post('/api/getClientContactInfo', utils.postParamsArrayToJsonString({ projectIds }))
  },
  addClientContactInfo (params) {
    return axios.post('/api/addClientContactInfo', utils.postParamsArrayToJsonString({ ...params }))
  },
  modifyClientContactInfo (params) {
    return axios.post('/api/modifyClientContactInfo', utils.postParamsArrayToJsonString({ ...params }))
  },
  deleteClientContactInfo (projectId) {
    return axios.post('/api/deleteClientContactInfo', utils.postParamsArrayToJsonString({ projectId }))
  },


  // 服务规格
  getSpecificationConfigInfo(projectIds) {
    return axios.post('/api/getSpecificationConfigInfo', utils.postParamsArrayToJsonString({ projectIds }))
  },
  addServiceSpecification(params) {
    return axios.post('/api/addServiceSpecification', utils.postParamsArrayToJsonString({ ...params }))
  },
  modifySpecificationConfig(params) {
    return axios.post('/api/modifySpecificationConfig', utils.postParamsArrayToJsonString({ ...params }))
  },
  deleteServiceSpecification(projectId) {
    return axios.post('/api/deleteServiceSpecification', utils.postParamsArrayToJsonString({ projectId }))
  },

  // 项目所属区域信息
  getProjectInServiceRegion(projectId) {
    return axios.post('/api/getProjectInServiceRegion', utils.postParamsArrayToJsonString({ projectId }))
  },
  addProjectInServiceRegion(params) {
    return axios.post('/api/addProjectInServiceRegion', utils.postParamsArrayToJsonString({ ...params }))
  },
  getProjectInServiceRegion(projectId) {
    return axios.post('/api/getProjectInServiceRegion', utils.postParamsArrayToJsonString({ projectId }))
  },

   // 项目服务范围信息
  addProjectServiceScope (params) {
    return axios.post('/api/addProjectServiceScope', utils.postParamsArrayToJsonString({ ...params }))
  },
  getProjectServiceScope (projectId) {
    return axios.post('/api/getProjectServiceScope', utils.postParamsArrayToJsonString({ projectId }))
  },
  deleteProjectServiceScope (params) {
    return axios.post('/api/deleteProjectServiceScope', utils.postParamsArrayToJsonString({ ...params }))
  },

}

export default contract